export const POINTS_WIN = 3;
export const POINTS_NEAR_LOSS = 1;
export const POINTS_LOSS = 0;
export const NEAR_LOSS_MARGIN = 1;

export function pointsEarnedInMatch (match, playerId) {
  const playerTeam = match.teams.find(t => t.playerIds.includes(playerId));
  if (!playerTeam) return POINTS_LOSS;
  const maxGoals = Math.max(...match.teams.map(t => t.goals));
  if (playerTeam.goals === maxGoals) return POINTS_WIN;
  if (match.teams.length === 2 && (maxGoals - playerTeam.goals === NEAR_LOSS_MARGIN)) return POINTS_NEAR_LOSS;
  return POINTS_LOSS;
}
